import React from 'react'
import Proptypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { useFormApi, useFieldState } from 'informed'

import CheckedList from './CheckedList'
import { Checkbox, Text } from '../'
import style from './CheckedList.module.scss'

const GroupedCheckboxes = ({ field, boolField = 'active', labelField = 'label', listChecked, cols = 1, hiddenItems, checkboxHeight = 26, styleInverted }) => {
	const formApi = useFormApi()
	const { value = [] } = useFieldState(field)
	const getItems = values => {
		const checkedList = []
		const checkBoxes = value.map((val, i) => {
			const isHidden = Array.isArray(hiddenItems) && hiddenItems.length
				? hiddenItems.find(({ identifier }) => identifier === val.identifier)
				: false
			const props = {
				field: `${field}[${i}].${boolField}`,
				label: val[labelField],
				key: i,
				styleInverted
			}
			if(listChecked && val[boolField]) {
				checkedList.push(<Checkbox {...props} noForm checked={true} readOnly />)
			}
			return isHidden ? null : <Checkbox {...props}/>
		})
		return { checkedList, checkBoxes }
	}
	const containerHeight = Math.ceil(value.length / cols) * checkboxHeight
	const uncheck = (i) => {
		formApi.setValue(`${field}[${i.key}].${boolField}`, false)
	}
	const { checkedList, checkBoxes } = getItems()

	return(
		<Row className={style['grouped-checkboxes']}>
			<Col
				style={cols > 1 ? { height: `${containerHeight}px` } : {}}
				className={style['list-checked-container']}
				sm={listChecked ? 8 : 12}
				xs={12}
			>
				<div><Text field={field} hidden /></div>
				{checkBoxes}
			</Col>
			{listChecked &&
				<Col
					sm={4}
					xs={12}
					className={style['list-checked-container']}
				>
					<CheckedList checkedItems={checkedList} onUncheck={uncheck} />
				</Col>
			}
		</Row>
	)
}

GroupedCheckboxes.propTypes = {
	field: Proptypes.string.isRequired,
	labelField: Proptypes.string,
	boolField: Proptypes.string,
	checkboxHeight: Proptypes.number,
	cols: Proptypes.number,
	listChecked: Proptypes.bool,
	// Array of items which will not be displayed if item has corresponding one in form values by the 'identifier' key value.
	hiddenItems: Proptypes.array,
	styleInverted: Proptypes.bool
}

export default GroupedCheckboxes
